import React, { useEffect } from 'react';
import clsx from 'clsx';
import { message } from 'antd';
import { useAppSelector } from 'shared/store';
import { Icon, IconName } from 'shared/components/Icon';
import './style.less';
import { Tooltip } from 'shared/components/Tooltip';

interface SessionChatUploadButtonProps {
  handleImageChange: (event: React.ChangeEvent<HTMLInputElement>) => Promise<void>;
  className?: string;
  tooltipTheme?: 'light' | 'dark';
  disabled?: boolean;
  customIcon?: IconName;
}

export const SessionChatUploadButton: React.FC<SessionChatUploadButtonProps> = ({
  className,
  handleImageChange,
  tooltipTheme = 'light',
  disabled = false,
  customIcon,
}) => {
  const { chatImageUploadDataUrl, chatImageUploadError } = useAppSelector(s => s.chat);

  useEffect(() => {
    if (chatImageUploadError) {
      message.error(chatImageUploadError);
    }
  }, [chatImageUploadError]);

  const inputId = '__sb_chat_file_img_input__';
  return (
    <div
      className={clsx([
        className,
        'SessionChatUploadButton',
        disabled && 'SessionChatUploadButton--disabled',
        !!chatImageUploadDataUrl && 'SessionChatUploadButton--disabled',
      ])}
    >
      <input
        id={inputId}
        type="file"
        accept="images/*"
        onChange={e => void handleImageChange(e)}
        disabled={!!chatImageUploadDataUrl}
      />
      <Tooltip title="Upload an image" theme={tooltipTheme ?? 'light'}>
        <label htmlFor={inputId}>
          <Icon icon={customIcon ?? 'picture'} />
        </label>
      </Tooltip>
    </div>
  );
};
